import { Injectable } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { scheduleOptionActions } from './schedule-option.actions';
import { scheduleOptionSelectors } from './schedule-option.reducer';

@Injectable({ providedIn: 'root' })
export class ScheduleOptionEffects {
   defaultFields: string[] = ['scheduleId', 'name'];

   defaultOrderingOptions: string[] = ['Name:asc'];

   staticFilters: string[] = [];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      scheduleOptionSelectors.selectState,
      'schedules',
      this.defaultFields,
      this.defaultOrderingOptions,
      scheduleOptionActions,
      this.staticFilters
   );

   constructor(private eagerSelectEffects: EagerSelectEffects<AppState>) {}
}
